import { Controller } from "@hotwired/stimulus"

/**
 * Refreshes the `from_step_attr` datalist whenever the operator picks a
 * different upstream step in the field-edit drawer. Without this, the
 * operator has to know the upstream target_model's column names by
 * heart — which they don't. The map is rendered server-side from
 * `pipeline_stage_from_step_attrs_map` and shipped as a JSON value.
 *
 * The datalist is just suggestions; the input is still free-text, so
 * power users can type anything (`audited_changes`, custom delegated
 * attributes) without being blocked.
 */
export default class extends Controller {
  static targets = ["fromStepSelect", "datalist"]
  static values = { map: { type: Object, default: {} } }

  declare readonly fromStepSelectTarget: HTMLSelectElement
  declare readonly datalistTarget: HTMLElement
  declare readonly mapValue: Record<string, string[]>

  connect(): void {
    this.refresh()
  }

  fromStepChanged(): void {
    this.refresh()
  }

  private refresh(): void {
    const stepId = this.fromStepSelectTarget.value
    const fromMap = this.mapValue[stepId] || []
    const fallback = ["id", "external_id"]
    const merged = Array.from(new Set([...fallback, ...fromMap]))

    this.datalistTarget.replaceChildren()
    for (const attr of merged) {
      const option = document.createElement("option")
      option.value = attr
      this.datalistTarget.appendChild(option)
    }
  }
}
